export interface Testimonial {
  id: number;
  name: string;
  quote: string;
  avatar?: string;
}

export const testimonials: Testimonial[] = [
  {
    id: 4,
    name: "Peter",
    quote:
      "You're super friendly, everyone was out to have a lovely time. The time element made it super fun!",
    avatar: "/images/avatars/peter.webp",
  },
  {
    id: 2,
    name: "Mikhail",
    quote:
      "Format is amazing — simple and fun! Would love to try quizbike or quiztriathlon next time.",
    avatar: "/images/avatars/mikhail.webp",
  },
  {
    id: 1,
    name: "Munissa",
    quote:
      "I wasn't even thinking about how boring running is. I was just thinking: 'I can't wait to get to the questions!'",
    avatar: "/images/avatars/munissa.webp",
  },
  {
    id: 3,
    name: "Irina",
    quote:
      "Nice distance, love competing with others! The questions were tough this time, maybe just me :) Would love bilingual quizzes — Russian and English.",
    avatar: "/images/avatars/placeholder.svg",
  },
  {
    id: 5,
    name: "Anna",
    quote:
      "Technically smooth, clear instructions, and I liked having questions after 2.5 km — perfect pacing!",
    avatar: "/images/avatars/placeholder.svg",
  },
  {
    id: 6,
    name: "Alex",
    quote: "It made running actually interesting. I'd never say that before!",
    avatar: "/images/avatars/placeholder.svg",
  },
];
